// SelectExam
export const SelectExam = [
    { value: '1', label: 'NEET' },
    { value: '2', label: 'JEE' },
    { value: '3', label: 'EAMCET' }
];

// SelectTest
export const SelectTest = [
    { value: '1', label: 'Grand' },
    { value: '2', label: 'Semi Grand' }
];

// TestName
export const TestName = [
    { value: '1', label: 'March Exam' },
    { value: '2', label: 'April Exam' }
];

// SelectClass
export const SelectClass = [
    { value: '1', label: 'Class 1' },
    { value: '2', label: 'Class 2' }
];

// SelectGroup
export const SelectGroup = [
    { value: '1', label: 'Group 1' },
    { value: '2', label: 'Group 2' }
];

// SelectRegion
export const SelectRegion = [
    { value: '1', label: 'Region 1' },
    { value: '2', label: 'Region 2' }
];

// SelectCluster
export const SelectCluster = [
    { value: '1', label: 'Cluster 1' },
    { value: '2', label: 'Cluster 2' }
];

// SelectBranch
export const SelectBranch = [
    { value: '1', label: 'Branch 1' },
    { value: '2', label: 'Branch 2' }
];

// SelectSections
export const SelectSections = [
    { value: '1', label: 'Section 1' },
    { value: '2', label: 'Section 2' }
];
